// import React from "react";
// import { Card, CardBody } from "reactstrap";
// import ReactApexChart from "react-apexcharts";

// const WalletOverView = ({ wallet }: any) => {
//   const options: any = {
//     chart: { toolbar: { show: !1 } },
//     dataLabels: { enabled: !1 },
//     stroke: { curve: "smooth", width: 2, dashArray: [0, 0, 3] },
//     fill: { type: "solid", opacity: [0.15, 0.05, 1] },
//     xaxis: {
//       categories: [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ],
//     },
//     colors: ["#f1b44c", "#556ee6", "#50a5f1"],
//   }

//   return (
//     <Card>
//       <CardBody>
//         <h4 className="card-title mb-3">Overview</h4>
//         <div>
//           <div id="overview-chart" dir="ltr">
//             <ReactApexChart
//               series={wallet.series.length ? wallet.series : {}}
//               options={options}
//               type="line"
//               height={240}
//               className="apex-charts"
//             />
//           </div>
//         </div>
//       </CardBody>
//     </Card>
//   );
// };

// export default WalletOverView;
import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const WalletOverView = () => {
  const options: any = {
    chart: { toolbar: { show: !1 } },
    dataLabels: { enabled: !1 },
    stroke: { curve: "smooth", width: 2, dashArray: [0, 0, 3] },
    fill: { type: "solid", opacity: [0.15, 0.05, 1] },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      ],
    },
    colors: ["#f1b44c", "#556ee6", "#50a5f1"],
  };

 const series = [
    {
      type: "area",
      name: "BTC",
      data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47],
    },
    {
      type: "area",
      name: "ETH",
      data: [28, 41, 52, 42, 13, 18, 29, 18, 36, 51, 55, 35],
    },
    {
      type: "line",
      name: "LTC",
      data: [45, 52, 38, 24, 33, 65, 45, 75, 54, 18, 28, 10],
    },
  ]

  return (
    <Card>
      <CardBody>
        <h4 className="card-title mb-3">Overview</h4>
        <div>
          <div id="overview-chart" dir="ltr">
              <ReactApexChart
                series={series}
                options={options}
                type="line"
                height={240}
                className="apex-charts"
              />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default WalletOverView;